export default {
  toQueryString: options => {
    let orderByDirection = options.sortBy[0]?.order || "asc";
    let orderBy = options.sortBy[0]?.key || "";
    let itemsPerPage = !options.itemsPerPage || options.itemsPerPage === -1 ? 100000 : options.itemsPerPage;

    return `page=${options.page ||
      1}&itemsPerPage=${itemsPerPage}&orderBy=${orderBy}&orderByDirection=${orderByDirection}`;
  },
};
